// extracted by mini-css-extract-plugin
export var externalLink = "_ae-0";
export var internalLinkLabel = "_ae-1";